import { render } from "./appointments_pages.vue?vue&type=template&id=9e82c19c"
import script from "./appointments_pages.vue?vue&type=script&lang=js"
export * from "./appointments_pages.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__